import { render, staticRenderFns } from "./navTpl.vue?vue&type=template&id=22fad35a&scoped=true&"
import script from "./navTpl.vue?vue&type=script&lang=js&"
export * from "./navTpl.vue?vue&type=script&lang=js&"
import style0 from "./navTpl.vue?vue&type=style&index=0&id=22fad35a&lang=scss&scoped=true&"
import style1 from "./navTpl.vue?vue&type=style&index=1&id=22fad35a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fad35a",
  null
  
)

export default component.exports